/*
 *		Copyright (c) 2011-2016 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .directive('accPublicPreview', ['SyncAndShareNode', 'WebPreview', function (SyncAndShareNode, WebPreview) {
        return {
            scope: {
                node: '=accPublicPreview'
            },
            link: function ($scope, $element) {
                var
                    queryParams = window.location.search.substring(1);

                if (queryParams.indexOf('act=view') > -1) {
                    WebPreview.open($scope.node);
                }

                $element.on('click', function(){
                    WebPreview.open($scope.node);
                });
            }
        }
    }]);
